import { IconName } from "../../../../styles/icons/icons";
import Icon from "../../Icon";
import { AvatarSize, avatarSizeToStylesMap } from "../consts";
import SecondaryCircle from "./SecondaryCircle";

type Props = {
  iconName: IconName;
  avatarSize: AvatarSize;
  accessibilityLabel: string | null;
};

export default function DisplayIcon({
  iconName,
  avatarSize,
  accessibilityLabel = null
}: Props) {
  const { secondaryCircleSize, secondaryCirclePadding } = avatarSizeToStylesMap[
    avatarSize
  ];
  return (
    <SecondaryCircle
      size={secondaryCircleSize}
      padding={secondaryCirclePadding}
      backgroundColor={"foreground"}
    >
      <Icon
        iconName={iconName}
        accessibilityLabel={accessibilityLabel}
        tone="neutral"
        size="fill"
      />
    </SecondaryCircle>
  );
}
